export * as inputStyleConfigs from './style-configs';
export { Input } from './input';
export type { InputProps, InputStyleConfig } from './types';
